import { render, staticRenderFns } from "./SupportChat.vue?vue&type=template&id=dadac996&scoped=true"
import script from "./SupportChat.vue?vue&type=script&lang=js"
export * from "./SupportChat.vue?vue&type=script&lang=js"
import style0 from "./SupportChat.vue?vue&type=style&index=0&id=dadac996&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadac996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dadac996')) {
      api.createRecord('dadac996', component.options)
    } else {
      api.reload('dadac996', component.options)
    }
    module.hot.accept("./SupportChat.vue?vue&type=template&id=dadac996&scoped=true", function () {
      api.rerender('dadac996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/support/modules/SupportChat.vue"
export default component.exports